function getHost(environment = "development") {
  if (environment === "production") {
    return "https://data.nrk.no";
  }
  return "https://no-nrk-prod1.mini.snplow.net";
}

export { getHost as g };
